import CloseIcon from '@mui/icons-material/Close';
import { Card,Dialog,DialogContent,DialogTitle,IconButton,Stack,Typography } from '@mui/material';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import { MdCancel } from 'react-icons/md';
import checkBrightness from '../../../helpers/checkBrightness';
import {
  DivItemsCabecMaior,
  DivItemsCabeMenor,
  H3Preview,
} from '../../../StyledComponents/Modal/generic';
import { PrintTemplateType } from '../../../types/print-template/types';
import { FormExampleContainer } from '../FormStyle';

export default function PrintPreviewCreateModal({
  printTemplate,
  openModal,
  setOpenModal
}
  : {
    printTemplate: PrintTemplateType,
    openModal: boolean,
    setOpenModal: Function
  }) {
  const { t } = useTranslation('translation');

  const componentRef = useRef(null);

  const itensEsquerda = [`Cliente:`, `Local:`, `Conjunto:`, `Unidade:`, `identificador:`, `Scoring:`];
  const itensDireita = [`Equipes:`, `Usuário:`, `Inicio:`, `Fim:`, `Aprovação:`, 'Range'];

  return (
    <Card>
      <Dialog
        fullWidth
        maxWidth='md'
        scroll='paper'
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <DialogTitle>{t('checklists.printPreview')}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setOpenModal(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers={true}>
          <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' width='100%' spacing={1}>
            <div style={{ fontSize: '14px' }}>
              Legenda:
              <p>
                <div className="icon-text">
                  <span className="icon has-text-success">
                    <IoMdCheckmarkCircle className='is-success' />
                  </span>
                  <span>{t('checklists.Modal.compliantEvaluation')}</span>
                </div>
              </p>
              <p>
                <div className="icon-text">
                  <span className="icon has-text-success">
                    <MdCancel className='icon has-text-danger is-small' />
                  </span>
                  <span>{t('checklists.Modal.nonCompliantEvaluation')}</span>
                </div>
              </p>
            </div>
            {!printTemplate.logo ? <></> : (
              <img alt="Logo da empresa" src={printTemplate?.logo} width={150} style={{ alignSelf: 'center', marginBottom: '10px' }} />
            )}
            <Stack
              alignItems='center'
              justifyContent='center'
              sx={{
                height: 80,
                backgroundColor: printTemplate.color,
                width: '100%',
                padding: 1
              }}>
              <Typography
                textAlign='center'
                fontWeight={printTemplate.headerText?.bold ? 600 : 500}
                fontSize={`${printTemplate.headerText?.size}px`}
                fontStyle={printTemplate.headerText?.italic ? 'italic' : 'normal'}
                sx={{
                  color: !printTemplate.color?.length ? 'black' : (checkBrightness(printTemplate?.color) ? 'black' : 'white'),
                }}
              >
                {printTemplate.headerText?.text}
              </Typography>
            </Stack>
            <FormExampleContainer ref={componentRef}>
              <>
                <h3>
                  {`${t('checklists.Modal.formName')}`}
                </h3>
                <H3Preview>
                  {`${t('checklists.companyName')}`}
                </H3Preview>
                <DivItemsCabecMaior className='columns'>
                  <DivItemsCabeMenor className='column'>
                    {itensEsquerda.map((elem, ind) => (
                      <p key={ind}>{elem}</p>
                    ))}
                  </DivItemsCabeMenor>
                  <DivItemsCabeMenor className='column'>
                    {itensDireita.map((elem, ind) => (
                      <p key={ind}>{elem}</p>
                    ))}
                  </DivItemsCabeMenor>
                </DivItemsCabecMaior>
              </>
              <div>
                <>
                  <Typography variant="h6" style={{ textDecoration: 'underline', color: 'gray' }}>
                    Nome do Item
                  </Typography>
                  <span style={{ fontWeight: '100' }}>
                    &nbsp;- Scoring:
                  </span>
                  <Typography variant='subtitle2' style={{ textDecoration: 'underline', color: 'gray' }}>
                    {t('checklists.Modal.subitems')}
                  </Typography>

                </>
                <ul>
                  <Typography style={{ color: 'gray', fontWeight: 'bold' }} variant='subtitle2'>
                    <div style={{ display: 'flex' }}>
                      <span style={{ fontWeight: 500 }}>
                        (1)
                      </span>&nbsp;
                      - {t('checklists.subitemName')}
                    </div>
                    <p style={{ color: 'gray', fontWeight: '300' }}>({t('checklists.Modal.subitemType')})</p>
                  </Typography>
                </ul>
              </div>
            </FormExampleContainer>
            <Stack
              alignItems='center'
              justifyContent='center'
              sx={{
                height: 80,
                backgroundColor: printTemplate.color,
                width: '100%',
                padding: 1
              }}>
              <Typography
                textAlign='center'
                fontWeight={printTemplate.footerText?.bold ? 600 : 500}
                fontSize={`${printTemplate.footerText?.size}px`}
                fontStyle={printTemplate.footerText?.italic ? 'italic' : 'normal'}
                sx={{
                  color: !printTemplate.color?.length ? 'black' : (checkBrightness(printTemplate?.color) ? 'black' : 'white'),
                }}
              >
                {printTemplate.footerText?.text}
              </Typography>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </Card>
  );
}
